import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/Hono.svg?component
var Hono_exports = /* @__PURE__ */ __exportAll({
	default: () => Hono_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "#FF5B11",
		d: "M12.371 1.736q.08-.01.141.04a76 76 0 0 1 4.217 5.662 28 28 0 0 1 2.49 4.659q1.64 4.374-1.707 7.61-2.928 2.475-6.747 1.928-4.564-.93-6.205-5.281a7.4 7.4 0 0 1-.28-2.891 17.3 17.3 0 0 1 1.204-4.9 7.3 7.3 0 0 1 1.044-1.767q.525.625 1.004 1.285.222.232.462.442a38 38 0 0 1 4.377-6.787",
		opacity: ".993"
	}, null, -1), createElementVNode("path", {
		fill: "#FF9758",
		d: "M12.09 5.962a42.5 42.5 0 0 1 3.996 5.462q.56.959.924 2.008.758 2.982-1.627 4.92-2.306 1.622-5.06.963-2.97-.921-3.433-3.996a4.25 4.25 0 0 1 .2-1.887c.297-.754.66-1.48 1.085-2.168L9.38 9.495q1.367-1.758 2.71-3.534Z"
	}, null, -1)])]);
}
var Hono_default = { render: render$1 };
//#endregion
export { Hono_exports, Hono_default as default, render$1 as render };

//# sourceMappingURL=Hono.svg.virtual.js.map